export default "__VITE_ASSET__bb68d1bf__"